import React from "react";
import { FormFieldProps } from "~/components/forms/FormFieldProps";
import { useCompanyRoles } from "~/refdata2/companyRoles";
import { SimplePicker } from "~/visuals/organisms/SimplePicker";

export const CompanyRolePicker: React.FC<FormFieldProps> = (props) => {
  const roles = useCompanyRoles() ?? [];
  const options = roles.map((x) => ({
    text: x,
    value: x,
  }));

  return <SimplePicker {...{ ...props, options }} />;
};
